__turbopack_context__.v({
  "action": "snackbar-module-scss-module__cpyMUG__action",
  "actionButton": "snackbar-module-scss-module__cpyMUG__actionButton",
  "actionHighlight": "snackbar-module-scss-module__cpyMUG__actionHighlight",
  "alertRoot": "snackbar-module-scss-module__cpyMUG__alertRoot",
  "content": "snackbar-module-scss-module__cpyMUG__content",
  "icon": "snackbar-module-scss-module__cpyMUG__icon",
  "longContent": "snackbar-module-scss-module__cpyMUG__longContent",
  "message": "snackbar-module-scss-module__cpyMUG__message",
  "oneAction": "snackbar-module-scss-module__cpyMUG__oneAction",
  "snackbarRoot": "snackbar-module-scss-module__cpyMUG__snackbarRoot",
  "storyDisplay": "snackbar-module-scss-module__cpyMUG__storyDisplay",
  "successIcon": "snackbar-module-scss-module__cpyMUG__successIcon",
  "twoActions": "snackbar-module-scss-module__cpyMUG__twoActions",
  "u-animation-bounce": "snackbar-module-scss-module__cpyMUG__u-animation-bounce",
});
